export default {
    category: "",
    created_by: "",
    date_last_examination: "",
    date_last_service: "",
    description: "",
    location_lat: "",
    location_lon: "",
    name: "",
    photo_url: "",
    qr_code_url: "",
    service_period: "",
    status: "",
    thorough_examination_period: "",
    timestamp: "",
    notes: "",
    uid: "",
    areas: [],
    departments: [],
};
